var _circle, _rect, _rect2, _path, _rect3, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPrescriptionLaptop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 120 120"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 60,
  r: 60,
  fill: "#F6F9FC"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 76.853,
  height: 12.108,
  x: 21.519,
  y: 77.726,
  fill: "#EBF0F5",
  rx: 6.054
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 60.372,
  height: 34.643,
  x: 32.113,
  y: 34.931,
  fill: "#60768F",
  opacity: 0.75,
  rx: 2.257
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#60768F",
  d: "M40.522 34.932H34.37a2.257 2.257 0 0 0-2.257 2.256v30.13a2.257 2.257 0 0 0 2.257 2.256h6.152V34.932Z"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 64.928,
  height: 39.535,
  x: 27.565,
  y: 34.667,
  stroke: "#36485C",
  strokeWidth: 1.667,
  rx: 3.68
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#36485C",
  strokeWidth: 1.667,
  d: "M28.647 74.019h62.765a3.68 3.68 0 0 1 3.25 1.953l1.637 3.082c1.302 2.45-.474 5.406-3.25 5.406H27.01c-2.775 0-4.551-2.955-3.249-5.406l1.637-3.082a3.68 3.68 0 0 1 3.25-1.953Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#C5CFD9",
  d: "m27.834 83.667 3.929-8.833h8.404l-3.097 8.833h-9.236Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M40.912 42.925c0-.369.299-.667.667-.667h36.92c.368 0 .667.298.667.666v29.593a.667.667 0 0 1-.667.667H41.58a.667.667 0 0 1-.667-.667V42.925Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.667,
  d: "M40.912 73.167V43.85a1.593 1.593 0 0 1 1.592-1.592h35.027a1.592 1.592 0 0 1 1.592 1.592v29.317M60.667 51.668h5.667M60.667 58.668H72M60.667 64.001H72"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#86B09B",
  d: "M48.815 57.866c0-1.197.97-2.167 2.167-2.167h5.462v10.29h-7.629v-8.123Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#B6CEC2",
  d: "M53.428 55.699h2.661v10.468h-2.661z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.167,
  d: "M54.347 53.613v-1.364h.577a.5.5 0 0 0 .5-.5v-1.582a.5.5 0 0 0-.5-.5h-7.097a.5.5 0 0 0-.5.5v1.582a.5.5 0 0 0 .5.5h.577v1.384c-.59.197-1.1.55-1.46 1.014a2.572 2.572 0 0 0-.553 1.58v8.338a1.5 1.5 0 0 0 1.5 1.5h7.035a1.5 1.5 0 0 0 1.5-1.5v-8.337c0-.575-.2-1.136-.573-1.605a3.084 3.084 0 0 0-1.506-1.01ZM54.532 52.333H48.5"
})));
export default SvgPrescriptionLaptop;